import React, { useEffect, useState } from 'react'
import './WebsiteBanner.css'
import { API_END_POINT, TOKEN } from '../../constant'
import { toast } from 'react-toastify'
import CommonTable from '../Table/CommonTable'
import Loader from '../Loader/Loader'
import Select from 'react-select'

function WebsiteBanner() {

    const [loading, setLoading] = useState(false);
    const [btnName, setBtnName] = useState("Add");
    const [showForm, setShowForm] = useState(false)
    const [selectedFile, setSelectedFile] = useState('')
    const [bannerList, setBannerList] = useState()
    // const [redirectionLink, setRedirectionLink] = useState()
    const [imageId, setImageId] = useState()
    const [selectedOption, setSelectedOption] = useState(null);
    const isActive = true;

    const options = [
        { value: '', label: 'No Redirection' },
        { value: '/blog', label: 'Blog' },
        { value: '/comingsoon', label: 'Coming Soon Screen' },
        { value: '/learnastroscience', label: 'Astrology Courses' },
        { value: '/numerology', label: 'Numerology' },
        { value: '/pujaList', label: 'Puja List Screen' },
        { value: '/fastandfestivalblogs', label: 'Fast And Festival Blogs' },
        { value: '/clock', label: 'Astro Clock' },
        { value: '/consultation/1', label: 'Basic Analysis' },
        { value: '/consultation/2', label: 'Full Analysis' },
        { value: '/consultation/3', label: 'Advance Analysis' },
        { value: '/#shop-section', label: 'Shop Section' },
        { value: '/aboutpage', label: `About Page` },
        { value: '/reports', label: 'Full Reports' },
        { value: '/personalizedReportsListUi', label: 'Personalized Reports' },
        { value: '/yogduryog', label: 'Yog-Duryog' },
        {value : '/astrologerlistscreen', label: 'Our Astrologers'}
    ];


    useEffect(() => {
        getWebsiteBannerList();
    }, [])


    const getWebsiteBannerList = async () => {
        setLoading(true)
        const getWebsiteBannerListUrl = `${API_END_POINT}websiteBanner/getWebsiteBannerList`
        const getWebsiteBannerListUrlHeaders = {
            'Content-Type': 'application / json',
            'Authorization': `Bearer ${TOKEN}`
        }

        try {
            const response = await fetch(getWebsiteBannerListUrl, { headers: getWebsiteBannerListUrlHeaders })
            if (!response.ok) {
                toast.error("error fetching website banner list")
                return
            }
            const responseData = await response.json();
            setBannerList(responseData.data);
        } catch (error) {
            console.log("getWebsiteBannerList error --->>> ", error)
        } finally {
            setLoading(false)
        }
    }

    const addWebsiteBanner = async () => {
        setLoading(true)
        const addWebsiteBannerUrl = `${API_END_POINT}websiteBanner/addNewWebsiteBanner`
        const addWebsiteBannerUrlHeaders = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${TOKEN}`
        }
        const body = {
            redirectionLink: selectedOption,
            fileId: imageId,
            active: isActive
        }
        try {
            const response = await fetch(addWebsiteBannerUrl, {
                method: 'POST',  // Added method type for clarity
                headers: addWebsiteBannerUrlHeaders,
                body: JSON.stringify(body)
            })

            if (!response.ok) {
                const errorData = await response.json();
                toast.error("Failed to add new Website Banner: ");
                return;
            }
            const responseData = await response.json();
            toast.success("Website Banner added successfully!");
            console.log("Response:", responseData);
            getWebsiteBannerList()
        } catch (error) {
            console.log("addWebsiteBanner error --->>> ", error);
            toast.error("Something went wrong, please try again.");
        } finally {
            setLoading(false)
        }
    }


    const handleSelect = (e)=>{
        setSelectedOption(e.value)
    }

    const handleAddWebsiteBanner = (e) => {
        console.log("fgfdgfdgf")
        e.preventDefault();
        if (!imageId) {
            toast.error("Banner can't be empty")
            return
        }
        addWebsiteBanner();
    }

    const addRow = () => {
        setSelectedOption();
        setImageId()
        if (btnName === "Save") {
            setBtnName("Add");
        }
        setShowForm(!showForm);
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
        } else {
            toast.error("No file selected");
        }
    };

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
    };

    const handleMainImageUpload = async (e) => {
        e.preventDefault();
        setLoading(true)
        if (!selectedFile) {
            toast.error('No image selected! Please select an image.');
            setLoading(false)
            return
        }
        const formData = new FormData();
        formData.append('file', selectedFile);

        try {
            const response = await fetch(`${API_END_POINT}fileAttachment/uploadImages`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${TOKEN}`,
                },
                body: formData,
            });
            if (!response.ok) {
                toast.error('Failed to upload image');
            }
            const data = await response.json();
            console.log("object", data)
            console.log("this image link is ", data.data.fileId)
            toast.success('Image uploaded successfully!');
            setImageId(data.data.fileId)
            console.log("image id ", imageId)
        } catch (error) {
            toast.error('Error uploading image');
        }
        finally {
            setLoading(false)
        }
    };

    const deleteWebsiteBanner = async (bannerId) => {
        setLoading(true)
        const deleteWebsiteBannerUrl = `${API_END_POINT}websiteBanner/deleteWebsiteBanner`
        const deleteWebsiteBannerUrlHeaders = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${TOKEN}`
        }
        try {
            const response = await fetch(`${deleteWebsiteBannerUrl}?websiteBannerId=${bannerId} `, { method: 'DELETE', headers: deleteWebsiteBannerUrlHeaders })
            if (!response.ok) {
                toast.error("failed to delete Website Banner")
            }
            toast.success("Website Banner deleted successfully")
            getWebsiteBannerList();
        } catch (error) {
            console.log("deleteWebsiteBanner --->>> ", error)
        } finally {
            setLoading(false)
        }
    }


    const columns = [
        {
            name: 'Sr. No.',
            cell: (row, index) => row?.id,
        },
        {
            name: "Redirection ",
            cell: (row) => row?.redirectionLink,
        },
        {
            name: "Banner",
            cell: (row) => <img
                title='Click to see Image'
                src={`${API_END_POINT}${row?.fileAttachmentLink}`}
                width={"auto"}
                height={"70"}
                alt="Blog Image"
            />
        },
        {
            name: 'Actions',
            cell: (row, index) => (
                <div className='flex align-center gap-10'>
                    <button className='flex align-center delete-btn-icon' onClick={() => deleteWebsiteBanner(row.id)}>
                        <svg width="25" height="25" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2v12ZM9 4h6v2H9V4ZM8 8h9v12H7V8h1Z"></path>
                            <path d="M9 10h2v8H9v-8Zm4 0h2v8h-2v-8Z"></path>
                        </svg>
                    </button>
                </div>
            ),
        },
    ];


    return (
        <main className='main'>
            <h3>Website Banner </h3>
            {!loading ? (
                <div>
                    <div style={{ marginTop: "10px" }} className='flex align-center justify-end'>
                        <button onClick={addRow} className='common-btn flex align-center'>
                            {!showForm ? "Add Website Banner" : "Cancel"}
                        </button>
                    </div>
                    {showForm && (
                        <form className='form'>
                            <div className=''>
                                <label htmlFor="blogName">Redirection Link</label>
                                {/* <input
                                    id='blogName'
                                    type="text"
                                    name="blogName"
                                    value={redirectionLink}
                                    onChange={(e) => (setRedirectionLink(e.target.value))}
                                    placeholder="Enter Redirection Link"
                                /> */}
                                <div className="App">
                                    <Select 
                                        defaultValue={selectedOption}
                                        onChange={handleSelect}
                                        options={options}
                                        styles={customStyles}
                                    />
                                </div>
                            </div>
                            <div className='input-field flex flex-col'>
                                <label htmlFor="blogName">Main Website Banner Image <br /> <span style={{opacity : '50%' , color : 'red' }} >(recommended size width : 300px height : 92px)</span> <br /> <span style={{opacity : '50%' , color : 'red' }} >(recommended : convert svg to png and then upload)</span> </label>
                                <input type="file" name="" onChange={handleImageUpload} id="fileupload" />
                                <button style={{ width: 'fit-content' }} className='common-btn flex align-center' onClick={handleMainImageUpload}>
                                    Add Main Image
                                </button>
                            </div>
                            <div className='buttons flex flex-col'>
                                <button type="submit" onClick={handleAddWebsiteBanner} className='btn'>{btnName}</button>
                            </div>
                        </form>
                    )}

                    <div style={{ marginTop: "10px" }}>
                        <CommonTable columns={columns} data={bannerList} value={false} />
                    </div>
                </div>
            ) : (
                <div>
                    <Loader />
                </div>
            )}
        </main>
    )
}

export default WebsiteBanner
